import React from 'react'
import PropTypes from 'prop-types'

const EntryAddedConfirmation = props => {
  return (
    <div className='entry-add-confirm'>
      <div className='modal-body'>
        {props.entry.title}
        <br />
        has been added to
        <br />
        <strong>{props.playlist.title}</strong>
        <div className='btn-wrapper center'>
          <button className='btn alo-button' onClick={props.onConfirmed}>
            Done
          </button>
        </div>
      </div>
    </div>
  )
}

EntryAddedConfirmation.propTypes = {
  entry: PropTypes.object,
  playlist: PropTypes.object,
  onConfirmed: PropTypes.func
}

export default EntryAddedConfirmation
